<template>
  <div>
    <v-input
      :rules="$attrs.rules"
      @click="$emit('edit', false)"
      v-if="$slots.editable"
      class="v-text-field ml-0 iris-mimic"
    >
      <label v-bind="$attrs" class="v-label v-label--active theme--light pos-absolute">{{ $attrs.label }}</label>
      <v-icon>{{ prepIcon }}</v-icon>
      <a v-mutate="onMutate" :class="getLinkMargins" target="getOpeningMode" class="linkIris input" :href="goTo">
        <slot name="editable"></slot>
      </a>
      <v-spacer></v-spacer>
      <v-icon @click.stop="$emit('edit', false)">mdi-pencil</v-icon>
    </v-input>
    <a v-else target="_blank" class="linkIris" :href="goTo">
      <slot></slot>
    </a>
  </div>
</template>

<script>
import { ednRegex } from './mixins/ednRegex'
import { ednRequired } from './mixins/ednRequired'

export default {
  inheritAttrs: false,
  mixins: [ednRegex, ednRequired],
  data() {
    return {
      editingFromOutside: false,
    }
  },
  props: {
    linkMode: {
      type: String,
      default: () => '',
    },
    prepIcon: {
      type: String,
      default: () => '',
    },
    oType: {
      type: Object,
      default: function() {
        return {
          phone: 'tel:',
          mail: 'mailto:',
          url: 'http://',
        }
      },
    },
  },
  methods: {
    /**
     * On vérifie si le contenu respecte la regex du champs parent ou non, sinon on envoie au parent l'info
     * Ne vérifie que si le lien dépend d'un champs parent et pas si le lien est autonome.
     */
    onMutate() {
      if (!this.pattern.test(this.getContent)) {
        this.$emit('validationMode', false)
        this.editingFromOutside = true
      }
    },
  },
  computed: {
    /**
     * Définit le lien du composant en fonction du type et si le contenu est rempli.
     */
    goTo() {
      if (Object.values(this.$slots) && Object.values(this.$slots).length > 0)
        return (this.oType[this.linkMode] + this.getContent);
      else
        return false;
    },
    /**
     * Met des paddings en fonctions de la présence d'un icône devant le champs
     */
    getLinkMargins() {
      return this.prepIcon ? 'px-1' : ''
    },
    /**
     * Définit le mode d'ouverture du lien en fonction du type d'url.
     */
    getOpeningMode() {
      return this.linkMode == 'url' ? '_blank' : '_self'
    },
    /**
     * Retourne le contenu de la slot si celle-ci est remplie
     */
    getContent(){
      return Object.values(this.$slots) ? Object.values(this.$slots).flat(1)[0].text.trim() : '';
    }
  },
  destroyed() {
    //Une fois le composant détruit on envoie au parent l'info pour qu'il puisse agir si besoin, sauf dans le cas où celui-çi est édité de l'extérieur.
    if (!this.editingFromOutside) this.$emit('focused', true)
  },
}
</script>

<style lang="scss">
.v-application {
	a {
		&.linkIris {
			padding: 3px 0 2px 0;
			cursor: pointer;
			text-decoration: underline;
			color: #1ca6fd;
			cursor: pointer;
			label {
				position: absolute;
			}
		}
	}
}

</style>
